
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useOffers = () => {
  return useQuery({
    queryKey: ['offers'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('offers')
        .select('*')
        .eq('is_active', true)
        .order('display_order');

      if (error) {
        console.error('Erreur lors de la récupération des offres:', error);
        throw error;
      }

      return data || [];
    },
  });
};
